import type { UserSessionRepository } from "@authentication/domain/repositories/user-session.repository";
import { authenticationTypes } from "@authentication/root/authentication-types.di";
import type { LanguageRepository } from "@iot-platform/core";
import { coreTypes, isLanguageIsoCode } from "@iot-platform/core";
import { inject, injectable } from "inversify";

@injectable()
export class AuthenticatedUserLoadCurrentUseCase {
    constructor(
        @inject(authenticationTypes.repositories.UserSessionRepository)
        private readonly userSessionRepository: UserSessionRepository,
        @inject(coreTypes.repositories.LanguageRepository)
        private readonly languageImplRepository: LanguageRepository,
    ) {}

    async execute(): Promise<boolean> {
        const currentUserResult =
            await this.userSessionRepository.loadCurrentUser();

        if (currentUserResult.isOk()) {
            const currentLanguageResult =
                this.languageImplRepository.getCurrent();

            const userLanguage = currentUserResult.match(
                (user) => user.language,
                () => null,
            );

            if (
                userLanguage &&
                currentLanguageResult.isOk() &&
                !(
                    isLanguageIsoCode(currentLanguageResult.value) &&
                    currentLanguageResult.value === userLanguage
                )
            ) {
                const updateLanguageResult =
                    await this.languageImplRepository.update(userLanguage);
                if (updateLanguageResult.isErr()) {
                    return false;
                }
            }
        }

        return currentUserResult.isOk();
    }
}
